import request from './request';
import api from './api';
import { getCipParams } from 'utils/getValue';

// 登录
export function login(params = {}) {
  return request('POST', api.login, params);
}

// 获取token
export function getAccessToken(params = {}) {
  return request('POST', api.getAccessToken, params);
}

// 凭证页首页
export function getQrcodeIndex(params = {}) {
  return request('GET', api.getQrcodeIndex, params);
}

// 查看使用记录
export function getRecordList(params = {}) {
  return request('GET', api.getRecordList, params);
}

// 查看休息室网络
export function getNetworkList(params = {}) {
  return request('GET', api.getNetworkList, params);
}

// 刷新二维码
export function getflushQrcode(params = {}, traceId) {
  const options = traceId
    ? {
        headers: {
          'Qrcode-TraceId': traceId,
        },
      }
    : {};
  return request('GET', api.getflushQrcode, params, options);
}

// 条形码数字
export function getBarcode(params = {}) {
  return request('GET', api.getBarcode, params);
}

// 机场下可用的休息室 20230223 文彬改过一版全新样式，用v2借口
export function getNetworkDetailV2(params = {}) {
  return request('POST', api.getNetworkDetailV2, params);
}

// 机场下可用的休息室 20241010 文彬改过一版,韬哥增加接口v3，在v2基础上增加三字码查询
export function getNetworkDetailV3(params = {}) {
  return request('POST', api.getNetworkDetailV3, params);
}

// 机场下可用的休息室
export function getNetworkDetail(params = {}) {
  return request('GET', api.getNetworkDetail, params);
}

// 休息室详情
export function getLoungeDetail(params = {}) {
  return request('GET', api.getLoungeDetail, params);
}

// 获取单次使用记录
export function getRecord(params = {}) {
  return request('GET', api.getRecord, params);
}

// cip登录
export function cipLogin(params = {}) {
  return request('GET', api.cipLogin, params);
}
// 获取cip信息
export function getCipInfo(params = {}) {
  const cipParams = getCipParams();
  return request('GET', api.getCipInfo, { ...cipParams, ...params });
}
// 获取cip网络列表
export function getCipNetworkList(params = {}) {
  const cipParams = getCipParams();
  return request('GET', api.cipNetworkList, { ...cipParams, ...params });
}
// 获取cip网点数据
export function getCipNetworkDetail(params = {}) {
  const cipParams = getCipParams();
  return request(
    'POST',
    api.cipnetworkDetail,
    { ...cipParams, ...params },
    {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    },
  );
}

// 获取cip二维码刷新
export function getCipFlushQrcode(params = {}) {
  const cipParams = getCipParams();
  return request('GET', api.getCipFlushQrcode, { ...cipParams, ...params });
}
// 获取餐厅网络列表
export function getMealNetworkList(params = {}) {
  return request('POST', api.getMealNetworkList, params, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });
}
// 获取餐厅网点详情
export function getMealNetworkDetail(params = {}) {
  return request('POST', `${api.getMealNetworkDetail}/${params.sid} `, params, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });
}
// 获取餐厅详情
export function getMealProDetail(params = {}) {
  return request('POST', `${api.getMealProDetail}/${params.id} `, params, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });
}

// 购买携伴点数
export function buyPoint(params = {}) {
  return request('POST', api.buyPoint, params, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });
}

// 获取车次列表
export function getNetworkTrainList(params = {}) {
  return request('GET', api.getNetworkTrainList, params);
}

// 高铁套餐接口
export function getNetworkRailCombosetList(params = {}) {
  return request('GET', api.getNetworkRailCombosetList, params);
}
